<template>
    <div class="job">
        <div class="job-content">
            <h2>招聘职位</h2>
            <div class="job-swiper-container" ref="jobPages">
                <div class="swiper-wrapper">
                    <div class="swiper-slide swiper-no-swiping" v-for="(page,index1) in pages" :key="index1" >
                        <ul class="job-list">
                            <li @touchstart="highlight(index1*4 + index2)" 
                                @touchend="recover(index1*4 + index2)" 
                                v-for="(item,index2) in page" :key="item.id">
                                <i class="iconfont icon-shuqian"></i>
                                <h4>{{item.title}}</h4{>
                                <span>{{getDate(item.update_time)}}</span>
                                <p>{{item.account}}</p>
                                <div @click="jobDetail(item.id)">查看详情<i class="iconfont icon-yousanjiaoxing"></i></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="swiper-tool">
                <i class="job-swiper-button-prev iconfont icon-jiantouzuo"></i><i class="job-swiper-button-next iconfont icon-icon_arrow_right"></i>
                <div class="job-swiper-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'Job',
    props:{
        jobList: Array
    },
    data () {
        return {

        }
    },
    mounted () {
        
    },
    methods: {
        imgSwiper () {
            var swiper = new Swiper('.job-swiper-container', {
                slidesPerView: 1,
                noSwiping : true,
                navigation: {
                    nextEl: '.job-swiper-button-next',
                    prevEl: '.job-swiper-button-prev',
                },
                pagination: {
                    el: '.job-swiper-pagination',
                    type: 'fraction'
                },
                autoHeight: true,
            });
        },
        highlight (id) {
            this.$refs.jobPages.getElementsByTagName('li')[id].getElementsByTagName('div')[0].className = "highlight"
        },
        recover (id) {
            this.$refs.jobPages.getElementsByTagName('li')[id].getElementsByTagName('div')[0].className = ""
        },
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        },
        jobDetail (id) {
            this.$router.push('/m_job/'+id);
        }
    },
    computed: {
        pages () {
            const pages = []
            this.jobList.forEach((item,index)=>{
                const page = Math.floor(index/4);
                if(!pages[page])
                    pages[page] = []
                pages[page].push(item)
            })
            return pages
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/mixins.styl'
    @import '~styles/varible.styl'
    .job >>> .swiper-button-disabled
                color: #999 !important
    .job 
        background: #f6f6f6
        .job-content
            padding: 0.92rem 4% 12%
            text-align: center
            h2
                color: #333
                font-size: 0.4rem
                font-weight: 800
                margin-bottom: 0.46rem
                letter-spacing: 1px
            .job-swiper-container
                width: 100%
                overflow: hidden
                text-align: left
                .job-list
                    width: 100%
                    li
                        padding: 0 6% 0.56rem
                        background: #fff
                        margin-top:  6%
                        overflow: hidden
                        >i
                            color: $yellow
                            font-size: 0.54rem
                            line-height: 0.8em
                        h4
                            font-weight: 800
                            color: #000
                            font-size: 0.32rem
                            margin: 0.3rem 0 0.18rem
                        span
                            color: #999
                            font-size: 0.24rem
                            line-height: 2em
                        p
                            font-size: 0.3rem
                            color: #666
                            margin-top: 0.34rem
                            line-height: 1.4em
                            text-ellipsis()
                        >div
                            float: right
                            margin-top: 0.34rem
                            width: 35%
                            color: #666
                            font-size: 0.28rem
                            line-height: 2em
                            text-align: center
                            border: 1px solid #aaa
                            border-radius: 2em
                            cursor: pointer
                            i
                                margin-left: 0.18rem
                                font-size: 0.2rem
                                margin-top: -0.1rem
                        .highlight
                            background: $yellow
                            color: #fff
                            border: 1px solid $yellow
                    li:first-of-type
                        margin-top: 0
            .swiper-tool
                margin-top: 0.48rem
                i
                    display: inline-block
                    padding: 0 4%
                    line-height: 3em
                    background: $black
                    color: #fff
                    font-size: 0.24rem
                >div
                    margin-top: 0.18rem
                    font-size: 0.24rem
</style>


// WEBPACK FOOTER //
// src/components/mobile/JoinJob.vue